<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/qualification/work/procedure/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <!-- <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('zizhibianhao')">
            <el-input v-model="yt.conditions.qualNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('zizhimingcheng')">
            <el-input v-model="yt.conditions.qualName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template> -->
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1');" type="primary" v-if="utils.checkPower('web_employment_management_qualification_work_procedure_create')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <!-- <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template> -->
      <!-- 操作列 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <!-- <el-col :span="0.1" v-if="utils.checkPower('web_employment_management_qualification_update_button')">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1')">
              {{ $t('bianji') }}
            </el-button>
          </el-col> -->
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_employment_management_qualification_work_procedure_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/qualification/work/procedure/delete')">{{ $t("shanchu") }}</el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增或编辑 -->
      <template v-if="yt.editObj.action == 'xinzeng'"">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <!-- 工序 -->
           <el-form-item :label="$t('gongxu')">
            <el-select v-model="yt.editObj.workProcedureId" :placeholder="$t('qingxuanze')">
              <el-option v-for="item in procedureList" :key="item.id" :label="item.desc+' | '+item.code" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false;">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="handleAdd" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "web_employment_management_qualification_work_procedure",
  data() {
    return {
      procedureList: [],
      loading:false,
      columns: [
        {
          label: 'gongxubianma',
          prop: 'workProcedure.code'
        },
        {
          label: 'gongxumiaoshu',
          prop: 'workProcedure.desc'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ],
    }
  },
  created() {
    setTimeout(() => {
      this.getWorkProcedureData();
      console.log('qwp', this.$attrs.qwp)
      this.yt.conditions = {
        qualificationId: this.$attrs.qwp.id,
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    handleAdd() {
      this.$set(this.yt.editObj, 'qualificationId', this.$attrs.qwp.id);
      this.yt.req('POST', '/web/qualification/work/procedure/create');
    },
    //查询工序下拉选数据
    getWorkProcedureData() {
      this.http.get('/web/craft/basic/work/procedure/list').then(res => {
          this.procedureList = res.data;
        }).catch(err => {
          console.log(err);
        });
    },
  }
}
</script>

<style scoped>

</style>